import {
  apiPrefix,
  ConnectionService,
  httpMethodType,
} from './Connecion.service';

// Const
import nuclias from '../const/nuclias';

const RESOURCE = 'auth/User';

class AuthUserService extends ConnectionService {
  constructor() {
    super();
    this.basedUrl = `${apiPrefix}/${RESOURCE}`;
  }

  async getUserUnreadCount() {
    const url = `${this.basedUrl}/alert/logs/unreadCount`;
    return super.sendRequest(url, {}, true); // {} default = GET
  }

  async getUser(userId = null) {
    let url = `${this.basedUrl}`;

    if (userId) {
      url = `${this.basedUrl}/${userId}`;
    }

    return super.sendRequest(url, {}, true);
  }

  async postWebSetting(data) {
    let config = {
      method: httpMethodType.post,
      body: JSON.stringify(data.webSetting),
    };
    const url = `${this.basedUrl}/${data.id}/webSetting`;
    return super.sendRequest(url, config, true);
  }

  async putUser(data) {
    let config = {
      method: httpMethodType.put,
      body: JSON.stringify(data),
    };
    const url = `${this.basedUrl}/${data.id}`;
    return super.sendRequest(url, config, true);
  }

  async putPassword(data) {
    let passwordValue = {
      password: data.password,
      confirmPassword: data.confirmPassword,
    };
    let config = {
      method: httpMethodType.put,
      body: JSON.stringify(passwordValue),
    };
    const url = `${this.basedUrl}/${data.id}/password`;
    return super.sendRequest(url, config, true);
  }

  async postVerify(data) {
    let config = {
      method: httpMethodType.post,
      body: JSON.stringify(data),
    };
    const url = `${this.basedUrl}/totp/verify`;

    return await super.sendRequest(
      url,
      {
        method: httpMethodType.post,
        headers: {
          'Content-Type': 'application/json',
        },
        body: config.body,
        mode: 'cors',
      },
      true
    );
  }

  async postUploadPhoto(file) {
    const url = `${this.basedUrl}/profilePhoto`;

    const formData = new FormData();
    const imageFile = file;
    formData.append('profilePhoto', imageFile);

    const config = {
      method: httpMethodType.post,
      headers: {},
      body: formData,
    };

    return super.sendRequest(url, config, true);
  }

  async sendEmail() {
    const url = `${this.basedUrl}/sendProfile`;
    const config = {
      method: httpMethodType.post,
    };

    return super.sendRequest(url, config, true);
  }

  async deleteAccount(data) {
    const url = `${this.basedUrl}/bulkDelete`;
    const config = {
      method: httpMethodType.post,
      body: JSON.stringify(data)
    };

    return super.sendRequest(url, config, true);
  }


  async deleteUploadPhoto() {
    const url = `${this.basedUrl}/profilePhoto`;
    const config = {
      method: httpMethodType.delete,
    };
    return super.sendRequest(url, config, true);
  }

  async getTwoFAGoogleQR() {
    const url = `${this.basedUrl}/totp`;
    return super.sendRequest(url, {}, true);
  }

  async getUserApiKeys(userId) {
    const url = `${this.basedUrl}/${userId}/keys`;
    return super.sendRequest(url, {}, true);
  }

  async updateUserApiKeysName(userId, keyId, newApiKeyName) {
    const putData = {
      name: newApiKeyName,
      scopes: ['all'],
    };
    const url = `${this.basedUrl}/${userId}/keys/${keyId}`;
    return super.sendRequest(
      url,
      {
        method: httpMethodType.put,
        body: JSON.stringify(putData),
      },
      true
    );
  }

  async generateUserApiKey(userId, modalApiKeyName) {
    const postData = { name: modalApiKeyName, scopes: ['all'] };
    const url = `${this.basedUrl}/${userId}/keys`;
    return super.sendRequest(
      url,
      {
        method: httpMethodType.post,
        body: JSON.stringify(postData),
      },
      true
    );
  }

  async revokeUserApiKey(userId, revokeDataArray) {
    const postData = { keys: revokeDataArray };
    const url = `${this.basedUrl}/${userId}/keys/revoke`;
    return super.sendRequest(
      url,
      {
        method: httpMethodType.post,
        body: JSON.stringify(postData),
      },
      true
    );
  }

  async getRecentLogins() {
    const url = `${this.basedUrl}/loginRecords?daysAgo=${nuclias.recordPeriod}`;
    return super.sendRequest(url, {}, true);
  }

  async postInviteUser(postData) {
    const url = `${this.basedUrl}/invite`;
    return super.sendRequest(
      url,
      {
        method: httpMethodType.post,
        body: JSON.stringify(postData),
      },
      true
    );
  }

  async updatePrivilege(userId, updatedData) {
    const url = `${this.basedUrl}/${userId}/privilege`;
    return super.sendRequest(
      url,
      {
        method: httpMethodType.put,
        body: JSON.stringify(updatedData),
      },
      true
    );
  }

  async asyncUpdatePrivilege(userId, updatedData) {
    const url = `${this.basedUrl}/${userId}/privilege`;
    return super.sendRequest(
      url,
      {
        method: httpMethodType.put,
        body: JSON.stringify(updatedData),
      },
      true
    );
  }

  async updateUser(userId, updatedData) {
    const url = `${this.basedUrl}/${userId}`;
    return super.sendRequest(
      url,
      {
        method: httpMethodType.put,
        body: JSON.stringify(updatedData),
      },
      true
    );
  }

  async postResend(userId, email) {
    const url = `${this.basedUrl}/${userId}/resend`;
    const postData = { email };

    return super.sendRequest(
      url,
      {
        method: httpMethodType.post,
        body: JSON.stringify(postData),
      },
      true
    );
  }

}

export default new AuthUserService();
